import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const GoogleCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();

  useEffect(() => {
    const handleGoogleCallback = async () => {
      try {
        // Get the token from URL parameters
        const token = searchParams.get('token');
        const userType = searchParams.get('userType');
        
        if (token && userType) {
          // Set the token in cookies/localStorage if needed
          document.cookie = `manu=${token}; path=/; max-age=86400`;
          
          // Redirect based on user type
          if (userType === 'admin') {
            navigate('/metricas-dashboard');
          } else if (userType === 'profesionales') {
            navigate('/panel-empleado/perfil-empleado');
          } else if (userType === 'empresas') {
            navigate('/panel-empresa/perfil');
          } else {
            navigate('/');
          }
        } else {
          // If no token, redirect to home
          navigate('/');
        }
      } catch (error) {
        console.error('Error processing Google callback:', error);
        navigate('/');
      }
    };

    handleGoogleCallback();
  }, [navigate, searchParams, login]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div style={{ fontSize: '18px', marginBottom: '20px' }}>
        Processing Google OAuth...
      </div>
      <div style={{ 
        width: '40px', 
        height: '40px', 
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #fb5424',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default GoogleCallback;